<template>
  <modal
    :show="show"
    @close="closeModal"
    :show-close-button="leadsConfig.closeButton"
    :disable-backdrop-close="leadsConfig.backDropButton"
    :show-info-icon="leadsConfig.showInfoIcon"
    :show-close-outside-button="leadsConfig.showCloseOutsideButton"
  >
    <div
      v-if="leadsModel.Enabled"
      class="leadsContentDiv d-flex"
    >
      <div class="exhibitorLeads">
        <div
          class="my-3 mx-4"
          v-if="!requestSended"
        >
          <h5
            class="mb-4"
            v-html="leadsModel.Headline"
          />
          <p v-html="leadsModel.Description" />

          <template v-if="leadsModel.ContactEnabled">
            <div class="my-4">
              <h6 v-html="leadsModel.ContactHeadline" />
              <div
                v-for="item in leadsModel.ContactFields"
                :key="item.index"
                v-html="item"
              />
            </div>
          </template>

          <template v-if="leadsModel.TermsEnabled">
            <div class="leads-model__terms-text__wrapper my-4">
              <h6 v-html="leadsModel.TermsHeadline" />
              <a
                class="leads-model__terms-link"
                :href="leadsModel.ExternalLink ? leadsModel.ExternalLink : 'javascript:void(0)'"
                :target="leadsModel.ExternalLink ? '_blank' : ''"
                @click="displayTerms()"
              ><b v-html="leadsModel.TermsLink" /></a>
              <div
                class="termsText"
                v-if="showTerms"
                v-html="leadsModel.TermsText"
              />
              <template v-if="showTermsCustom">
                <div>
                  <br />
                  <label><span><input
                           class="mr-1"
                           type="checkbox"
                           v-model="leadsForm.termsAccepted"
                         /></span>
                    <span v-html="leadsModel.TermsCheckText" /></label>
                  <br />
                  <span
                    class="termsRequiredHint"
                    v-if="termsRequiredHint"
                    v-html="$t('IndustryLandingPage.please_accept_terms')"
                  />
                </div>
              </template>
            </div>
          </template>

          <template v-if="leadsModel.AdditionalTermsEnabled">
            <div class="leads-model__terms-text__wrapper my-4">
              <h6 v-html="leadsModel.AdditionalTermsHeadline" />
              <a
                class="leads-model__terms-link"
                href="javascript:void(0)"
                @click="showAdditionalTerms = !showAdditionalTerms"
              ><b v-html="leadsModel.AdditionalTermsLink" /></a>
              <div
                class="termsText"
                v-if="showAdditionalTerms"
                v-html="leadsModel.AdditionalTermsText"
              />
              <div>
                <br />
                <label><span><input
                         class="mr-1"
                         type="checkbox"
                         v-model="leadsForm.additionalTermsAccepted"
                       /></span>
                  <span v-html="leadsModel.AdditionalTermsCheckText" /></label>
                <br />
                <span
                  class="termsRequiredHint"
                  v-if="additionalTermsRequiredHint"
                  v-html="$t('IndustryLandingPage.please_accept_terms')"
                />
              </div>
            </div>
          </template>

          <div>
            <b-button
              variant="primary"
              @click.prevent="submitLead()"
              :disabled="buttonDisabled"
              class="dataBtn mr-2"
            >
              <span v-html="$t('AppTranslations.submit_with_data')" />
            </b-button>
            <b-button
              v-if="leadsConfig.anonymBtn"
              variant="outline-primary"
              @click.prevent="anonymEnter()"
              :disabled="buttonDisabled"
              class="anonymBtn"
            >
              <span
                v-html="$t('AppTranslations.submit_anonymous')"
              />
            </b-button>
            <!-- <b-button variant="danger"
            @click="closeModal()"
            class="cancelBtn">{{ $t("IndustryLandingPage.cancel") }}</b-button> -->
          </div>
        </div>

        <!-- <div v-if="requestSended" class="leadsRequestConfirmation w-100">
          <span class="requestSendText">
            {{ $t("IndustryLandingPage.request_sended") }}
          </span>
        </div> -->
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'
import leadsRetrievalApi from '../leadsRetrieval'
import leadsMixins from '../../mixins/leadsMixins'
import trackingApi from '~/api/tracking'
import userState from '~/states/user'

export default {
  mixins: [
    leadsMixins,
  ],
  data() {
    return {
      leadsModel: [],
      showTerms: true,
      showAdditionalTerms: false,
      leadsForm: {
        leadsInputText: '',
        termsAccepted: false,
        additionalTermsAccepted: false,
      },
      termsRequiredHint: false,
      additionalTermsRequiredHint: false,
      requestSended: false,
      show: false,
      buttonDisabled: false,
      expirationDuration: 1000 * 60 * 60 * 72, // 3 days
      // remove after easd2021
      showTermsCustom: true,
    }
  },
  computed: {
    ...mapGetters({
      event: 'instancesState/getEvent',
      configForKey: 'config/configForKey',
      instance: 'instancesState/getInstance',
    }),
    loginStatus() {
      return userState.getUser(this.instance) ? !userState.getUser(this.instance)?.anonymousUser : !!userState.getUser(this.instance)
    },
    leadsConfig() {
      const config = this.configForKey('app_config').config[0]
      if (config.defaults.symposiaLeads) return config.defaults.symposiaLeads
      return {
        anonymBtn: true,
        closeButton: false,
        backDropButton: true,
        showInfoIcon: true,
        showCloseOutsideButton: true,
        acceptTerms: false,
        showCustomTerms: false,
        showAdditionalTerms: false,
      }
    },
  },
  props: {
    symposiaId: {
      type: Number,
      default: null,
    },
    callback: {
      type: Function,
      default: null,
    },
    eventFrame: {
      type: MessageEvent,
      default: null,
    },
  },
  async mounted() {
     if (!this.leadsModel.Enabled) {
      window.dispatchEvent(new CustomEvent('symposiaLeadsDone'))
    }
    // get model from API
    if (this.loginStatus) {
      this.leadsModel = await leadsRetrievalApi.getSymposiaLeadsModel(this.symposiaId)
      this.deleteLocalStorag()
      if (!localStorage.getItem(`symposiaLeadsAccepted${this.symposiaId}`)) {
        if (this.leadsModel.Enabled) {
          if (this.leadsConfig.acceptTerms) {
            await leadsRetrievalApi.addSymposiaLead(
              this.symposiaId,
              true,
              true,
              true,
            )
            this.setLocalStorage()
          } else {
            this.show = true
          }
        }
      }
    }
    if('showAdditionalTerms' in this.leadsConfig) {
      this.showAdditionalTerms = this.leadsConfig.showAdditionalTerms
    }

      if('showCustomTerms' in this.leadsConfig) {
      this.showTermsCustom = this.leadsConfig.showTermsCustom
    }

    if (this.leadsModel.Enabled === false) {
      this.show = false
      this.$emit('close')
    }
    // remove after easd2021
    const novoSessionIds = [
      45441,
      45435,
      45436,
      45437,
      45438,
      45439,
      45440,
      45442,
    ]
    if (this.event === 'easd2021' && novoSessionIds.includes(this.symposiaId)) {
      this.showAdditionalTerms = true
      this.showTermsCustom = false
    }
    //
  },

  components: { modal: () => import('../../Modal/index.vue') },
  methods: {
    async submitLead() {
      window.dispatchEvent(new CustomEvent('symposiaLeadsDone'))
      trackingApi.trackCustomAction('lionleads_session_lead_consent', this.symposiaId)

      if ((this.leadsModel.TermsEnabled || this.leadsModel.AdditionalTermsEnabled)
        && (this.leadsModel.TermsMandatory || this.leadsModel.AdditionalTermsMandatory)) {
        if (this.checkTerms(this.leadsModel, this.leadsForm)) {
          this.buttonDisabled = true
          await leadsRetrievalApi.addSymposiaLead(
            this.symposiaId,
            this.leadsForm.termsAccepted,
            this.leadsForm.additionalTermsAccepted,
            true,
          )
          this.termsRequiredHint = false
          this.additionalTermsRequiredHint = false
          // this.requestSended = true
          setTimeout(async () => {
            this.setLocalStorage()
            this.buttonDisabled = false
            this.show = false
            this.$emit('close')
          }, 1000)
        } else {
          if (this.leadsModel.TermsMandatory) {
            this.termsRequiredHint = true
          }
          if (this.leadsModel.AdditionalTermsMandatory) {
            this.additionalTermsRequiredHint = true
          }
        }
      } else {
        this.buttonDisabled = true
        await leadsRetrievalApi.addSymposiaLead(
          this.symposiaId,
          this.leadsForm.termsAccepted,
          this.leadsForm.additionalTermsAccepted,
          true,
        )
        // this.requestSended = true
        setTimeout(async () => {
          this.setLocalStorage()
          this.buttonDisabled = false
          this.show = false
          this.$emit('close')
        }, 1000)
      }
    },
    async anonymEnter() {
      window.dispatchEvent(new CustomEvent('symposiaLeadsDone'))
      trackingApi.trackCustomAction('lionleads_session_lead_noconsent', this.symposiaId)
      if ((this.leadsModel.TermsEnabled || this.leadsModel.AdditionalTermsEnabled)
        && (this.leadsModel.TermsMandatory || this.leadsModel.AdditionalTermsMandatory)) {
        if (this.checkTerms(this.leadsModel, this.leadsForm)) {
          this.buttonDisabled = true
          await leadsRetrievalApi.addSymposiaLead(
            this.symposiaId,
            this.leadsForm.termsAccepted,
            this.leadsForm.additionalTermsAccepted,
            false,
          )
          this.termsRequiredHint = false
          this.additionalTermsRequiredHint = false
          // this.requestSended = true
          setTimeout(async () => {
            this.setLocalStorage()
            this.buttonDisabled = false
            this.requestSended = false
            this.show = false
            this.$emit('close')
          }, 1000)
        } else {
          if (this.leadsModel.TermsMandatory) {
            this.termsRequiredHint = true
          }
          if (this.leadsModel.AdditionalTermsMandatory) {
            this.additionalTermsRequiredHint = true
          }
        }
      } else {
        this.buttonDisabled = true
        await leadsRetrievalApi.addSymposiaLead(
          this.symposiaId,
          this.leadsForm.termsAccepted,
          this.leadsForm.additionalTermsAccepted,
          false,
        )
        // this.requestSended = true
        setTimeout(async () => {
          this.setLocalStorage()
          this.buttonDisabled = false
          this.requestSended = false
          this.show = false
          this.$emit('close')
        }, 1000)
      }
    },
    setLocalStorage() {
      const prevAccepted = localStorage.getItem(
        `symposiaLeadsAccepted${this.symposiaId}`,
      )
      const currentTime = new Date().getTime()
      const notAccepted = prevAccepted === undefined || prevAccepted === null
      const prevAcceptedExpired = (prevAccepted !== undefined || true)
        && this.currentTime - prevAccepted > this.expirationDuration
      if (notAccepted || prevAcceptedExpired) {
        localStorage.setItem(
          `symposiaLeadsAccepted${this.symposiaId}`,
          currentTime,
        )
      }
    },
    deleteLocalStorag() {
      const prevAccepted = localStorage.getItem(
        `symposiaLeadsAccepted${this.symposiaId}`,
      )
      const currentTime = new Date().getTime()
      const prevAcceptedExpired = (prevAccepted !== undefined || true)
        && currentTime - prevAccepted > this.expirationDuration
      if (prevAcceptedExpired) {
        localStorage.removeItem(`symposiaLeadsAccepted${this.symposiaId}`)
      }
    },
    displayTerms() {
      if (this.showTerms) {
        this.showTerms = false
        return
      }
      this.showTerms = true
    },
    closeModal() {
      if (this.eventFrame) {
        this.eventFrame.source.postMessage('close', this.eventFrame.origin)
        this.show = false
        this.$emit('close')
      } else if (this.callback) {
        this.show = false
        this.callback()
        this.$emit('close')
      } else {
        this.$emit('close')
        window.history.back()
      }
    },
  },
}
</script>

<style scoped>
/* disclaimer modal */
@media (max-width: 500px) {
  .content {
    padding: 15px
  }
  .content .terms{
    display: inline-block;
  }
}

.contentDiv {
  position: relative;
  top: 20vh;
}
.content {
  width: 750px;
  min-height: 222px;
  background-color: white;
}
.content .title {
  font-size: 20px;
}
.content .text {
  font-size: 16px;
}
.disclaimerDialog {
  display: table;
  margin: 0 auto;
}
.disclaimerDialog .personalDataInfo{
  font-size: 14px;
}
.disclaimerDialog button {
  border: none;
  background-color: white;
}
.yesOption {
  color: #0057B8;
}
.noOption {
  color: black;
}
.termsRequiredHint {
  color: red;
  font-size: 10px;
}
.termsReqNote {
  color: red;
}
@media (max-width: 420px) {
  .contentDiv {
    top: 20px;
  }
}
</style>
